import { Box, Typography } from "@mui/material";
import React from "react";
import icon from "./yesnoicon.png"

function PrivacyPolicy() {
  return (
    <Box
      style={{
        width: "100vw",
        height: "100vh",
        padding: "25px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignContent: "center",
        alignItems: "center",
      }}
    >
        <img src={icon} style={{ width: "280px" }} ></img>
        <Typography variant="h3" style={{ margin: "10px" }}>
        Yes No Button
      </Typography>
      <Typography variant="h5" style={{ margin: "10px" }}>
        Privacy Policy
      </Typography>
      <Typography>
        The Yes No Button app doesn’t collect or use any information from your
        device and there is no data input into the app.
      </Typography>
    </Box>
  );
}

export default PrivacyPolicy;
